import { textStorages, TextStorage } from "./multilang-text-storage"

export type MenuOptionId = keyof TextStorage["menuOptions"]
export const MENU_OPTION_IDS = Object.keys(
  textStorages.hungarian.menuOptions,
) as MenuOptionId[]
